/* Música de fundo por aba (um <audio> em loop com crossfade) + preferências de áudio no navegador. */
import { wbSoundOn, setWbSound } from './wbSfx';

const readVol = (key, def) => {
  const v = parseFloat(localStorage.getItem(key));
  return Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : def;
};

export const getAudio = () => ({
  musicOn: localStorage.getItem('wb_music') !== 'off',
  musicVol: readVol('wb_music_vol', 0.35),
  sfxOn: wbSoundOn(),
});

let el = null;
let current = null;
let fadeTimer = null;
let duckTimer = null;

const fadeTo = (to, ms, then) => {
  if (!el) return;
  clearInterval(fadeTimer);
  const from = el.volume;
  const steps = Math.max(1, Math.round(ms / 40));
  let i = 0;
  fadeTimer = setInterval(() => {
    i += 1;
    if (!el) { clearInterval(fadeTimer); return; }
    el.volume = Math.min(1, Math.max(0, from + ((to - from) * i) / steps));
    if (i >= steps) { clearInterval(fadeTimer); then?.(); }
  }, 40);
};

const ensure = () => {
  if (!el) {
    el = new Audio(); el.loop = true; el.preload = 'auto';
    el.setAttribute('data-testid', 'wb-music'); el.style.display = 'none';
    document.body.appendChild(el);
  }
  return el;
};

export const music = {
  play: (src) => {
    ensure();
    const c = getAudio();
    if (!c.musicOn || c.musicVol === 0) { current = src; return; }
    if (current === src && el.getAttribute('src')) { if (el.paused) el.play().catch(() => {}); return; }
    const swap = () => {
      el.src = src; current = src; el.volume = 0;
      el.play().catch(() => {});
      fadeTo(c.musicVol, 700);
    };
    if (!el.paused && el.getAttribute('src')) fadeTo(0, 350, swap); else swap();
  },
  stop: () => { if (el) fadeTo(0, 300, () => el.pause()); },
  duck: (ms = 3000) => {
    if (!el || el.paused) return;
    const v = getAudio().musicVol;
    clearTimeout(duckTimer);
    fadeTo(v * 0.2, 150, () => { duckTimer = setTimeout(() => fadeTo(v, 900), ms); });
  },
  apply: () => {
    if (!el) return;
    const c = getAudio();
    if (!c.musicOn || c.musicVol === 0) { fadeTo(0, 200, () => el.pause()); return; }
    if (current && !el.getAttribute('src')) el.src = current;
    if (el.paused && el.getAttribute('src')) el.play().catch(() => {});
    fadeTo(c.musicVol, 200);
  },
};

export const setAudio = (patch) => {
  if ('musicOn' in patch) localStorage.setItem('wb_music', patch.musicOn ? 'on' : 'off');
  if ('musicVol' in patch) localStorage.setItem('wb_music_vol', String(patch.musicVol));
  if ('sfxOn' in patch) setWbSound(patch.sfxOn);
  music.apply();
  return getAudio();
};
